module.exports = __webpack_public_path__ + "static/media/typeb2.9992172f.jpg";